<template>
  <div class="yhc-component YhcCascader" :class="parentClass">
    <PrivateLabel v-if="label" :labelClass="labelClass" :label="label"></PrivateLabel>

    <div class="content">
      <el-cascader
        :options="labelCascaderOptions"
        class="el-component-item"
        @change="$_change"
        clearable
        v-model="result"
        :placeholder="placeholder"
      >
      </el-cascader>
    </div>

    <PrivateEndLabel
      :isBtnEndLabel="isBtnEndLabel"
      :endLabelType="endLabelType"
      v-if="endLabel"
      :endLabelStyle="endLabelStyle"
      :endLabel="endLabel"
      @tapEndLabel="$_tapEndLabel"
    ></PrivateEndLabel>
  </div>
</template>

<script>
import propsMixin from './componentsData/propsMixin';
import methodsMixin from './componentsData/methodsMixin';
import methodsMixin3 from './componentsData/methodsMixin3';
import mountedMixin from './componentsData/mountedMixin';

import PrivateLabel from './componentsData/PrivateLabel.vue';
import PrivateEndLabel from './componentsData/PrivateEndLabel.vue';

let identifierName = 'YhcCascader';

export default {
  name: identifierName,

  components: { PrivateLabel, PrivateEndLabel },
  mixins: [propsMixin, methodsMixin, methodsMixin3, mountedMixin],

  data() {
    return {
      result: this.value,
    };
  },
  props: {
    value: {
      type: Array,
      required: true,
    },
    labelCascaderOptions: {
      type: Array,
      required: true,
    },
  },
  computed: {},
  watch: {},
  methods: {},
  beforeCreate() {},
  created() {
    if (typeof this.value != 'object') {
      setInterval(() => {
        console.log(
          '%c' +
            'YhcCascader组件提示：使用此组件需要注意，这个与普通的组件数据不一样，v-model是一个array的类型',
          'color: #232222;background: #7fff00;'
        );
      }, 3000);
    }
  },
  mounted() {},
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
@import './componentsData/labelComponentCommonStyle';
.YhcCascader {
  @include labelCommon();
}
</style>
